import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import FicheDescriptiveProfessional from './FicheDescriptiveProfessional';
import AvailabilityBlock from './AvailabilityBlock';

function FicheDescriptivePage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [professional, setProfessional] = useState(null);
  const [availabilities, setAvailabilities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        const [proRes, availRes] = await Promise.all([
          axios.get(`https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod/prestataires/${id}`),
          axios.get(`https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod/professionals/${id}/weekly-availabilities`)
        ]);
        setProfessional(proRes.data);
        setAvailabilities(availRes.data);
      } catch (err) {
        console.error('Erreur récupération données:', err);
        alert("Impossible de récupérer les données du professionnel.");
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, [id]);

  return (
    <div style={{ padding: '20px' }}>
      <button onClick={() => navigate(-1)} style={{ marginBottom: '20px' }}>
        ← Retour
      </button>

      <h2>Fiche descriptive du professionnel</h2>

      {loading ? (
        <p>Chargement...</p>
      ) : (
        <>
          <FicheDescriptiveProfessional professional={professional} />
          <AvailabilityBlock availabilities={availabilities} />
        </>
      )}
    </div>
  );
}

export default FicheDescriptivePage;